'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
export default function LsqSodicFooter(props: MarketingPageComponentProps) {
  const footerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'footer' && section.enabled
  );
  if (!footerSection) return null;
  return (
    <>
      <Stack component="footer" className={cn.sodicFooterWrapper}>
        <Box className={cn.sodicFooterInner}>
          <ParallaxText
            variant="p"
            animationType="zoomIn"
            animationDuration={500}
          >
            {ReactHtmlParser(footerSection?.lsqSodicFooterElement)}
          </ParallaxText>
        </Box>
      </Stack>
    </>
  );
}
